var React = require('react');

function ArrowVector (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.1716 11H0V8.99998H20.1716L13.2787 2.10708L14.6929 0.692871L24 9.99998L14.6929 19.3071L13.2787 17.8929L20.1716 11Z","fill":"#DE7684"}));
}

ArrowVector.defaultProps = {"width":"24","height":"20","viewBox":"0 0 24 20","fill":"none"};

module.exports = ArrowVector;

ArrowVector.default = ArrowVector;
